import { numFormat as remoteNumFormat } from '@paywithextend/localization'

export const numFormat = (locale: string, num: number): string => {
  return remoteNumFormat(locale)(num)
}
